// @ts-nocheck
// Greif UI Kit = fill-sales-support
import * as React from "react";

const ChatPercent: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.692 2.747A2.315 2.315 0 0 1 22 5.055v10.769a2.315 2.315 0 0 1-2.308 2.308h-5.685a.8.8 0 0 0-.43.13l-3.628 2.434-2.511 2.054c-.824.674-2.084-.23-1.773-1.247.381-1.246.694-2.526.694-3.371H4.308A2.315 2.315 0 0 1 2 15.824V5.054a2.314 2.314 0 0 1 2.308-2.307zM14.7 5.931a.77.77 0 0 0-1.053.27L9.03 13.893a.77.77 0 0 0 1.322.785l4.616-7.692A.77.77 0 0 0 14.7 5.93m.377 6.047c-.846 0-1.538.692-1.538 1.538s.692 1.539 1.538 1.539 1.538-.693 1.538-1.539-.692-1.538-1.538-1.538M8.923 5.824c-.846 0-1.538.692-1.538 1.538s.692 1.539 1.538 1.539 1.538-.692 1.538-1.539c0-.846-.692-1.538-1.538-1.538"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ChatPercent);
